'use strict';

import './style.css';
import { sessid } from '../../common/baseData';

class ApplePayHelper {

    static get ajaxUrl() {
        return '/local/templates/tehnoezh-order-modern/apple_pay_ajax.php';
    }

    static get paymentFieldsMap() {
        return {
            'phoneNumber': 'PHONE',
            'emailAddress': 'EMAIL',
            'givenName': 'NAME',
            'familyName': 'LAST_NAME',
            'postalAddress': 'ADDRESS'
        };
    }

    static checkSession() {
        return (window.ApplePaySession && ApplePaySession.canMakePayments());
    }

    static makePayButton(className) {
        let button = document.createElement('div');
        button.className = 'order-apple-pay-button apple-pay-button-black';
        return button;
    }


    static makePaymentRequest(amount) {
        return {
            countryCode: 'UA',
            currencyCode: 'UAH',
            supportedNetworks: ['visa', 'masterCard'],
            merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
            total: {
                label: 'TehnoEzh',
                type: 'final',
                amount: amount
            },
            requiredShippingContactFields: [
                'name',
                'phone',
                'email'
            ],
            requiredBillingContactFields: [
                'postalAddress'
            ]
        };
    }

    static validateMerchant(validationURL) {
        let body = new FormData();
        body.append('action', 'validateMerchant');
        body.append('param', validationURL);
        body.append('sessid', sessid);
        return fetch(this.ajaxUrl, {
            method: 'POST',
            body: body
        });
    }

    static paymentAuthorized(data) {
        let body = new FormData();
        body.append('action', 'paymentAuthorized');
        body.append('param', data);
        body.append('sessid', sessid);
        return fetch(this.ajaxUrl, {
            method: 'POST',
            body: body
        });
    }

    static makePaymentFields(applePayPayment, orderFields) {
        let result = {};

        if (typeof orderFields === 'object')
            result = orderFields;


        if (applePayPayment.hasOwnProperty('shippingContact') 
            && (typeof applePayPayment.shippingContact === 'object')) {
            let shippingFields = applePayPayment.shippingContact;
            for (let i in shippingFields) {
                if (!shippingFields.hasOwnProperty(i)
                    || (shippingFields[i].trim().length <= 0)) continue;

                if (this.paymentFieldsMap.hasOwnProperty(i))
                    result[this.paymentFieldsMap[i]] = shippingFields[i];
                else
                    result[i] = shippingFields[i];
            }
        }

        if (applePayPayment.hasOwnProperty('billingContact')
            && (typeof applePayPayment.billingContact === 'object')) {
            result['ADDRESS'] = '';

            if(applePayPayment.billingContact.hasOwnProperty('addressLines')) {
                for(let i in applePayPayment.billingContact.addressLines) {
                    result['ADDRESS'] += ' '+applePayPayment.billingContact.addressLines[i];
                }
            }

            if(applePayPayment.billingContact.hasOwnProperty('locality')
                && applePayPayment.billingContact.locality.length) {
                if(result['ADDRESS'].length)
                    result['ADDRESS'] += ', ';

                result['ADDRESS'] += applePayPayment.billingContact.locality;
            }

            if(applePayPayment.billingContact.hasOwnProperty('administrativeArea')
                && applePayPayment.billingContact.administrativeArea.length) {
                if(result['ADDRESS'].length)
                    result['ADDRESS'] += ', ';

                result['ADDRESS'] += applePayPayment.billingContact.administrativeArea;
            }

            if(applePayPayment.billingContact.hasOwnProperty('country')
                && applePayPayment.billingContact.country.length) {
                if(result['ADDRESS'].length)
                    result['ADDRESS'] += ', ';

                result['ADDRESS'] += applePayPayment.billingContact.country;
            }

            if(applePayPayment.billingContact.hasOwnProperty('postalCode')
                && applePayPayment.billingContact.postalCode.length) {
                if(result['ADDRESS'].length)
                    result['ADDRESS'] += ', ';

                result['ADDRESS'] += applePayPayment.billingContact.postalCode;
            }


            result['ADDRESS'] = result['ADDRESS'].trim();
        }

        if (result.hasOwnProperty('NAME') || result.hasOwnProperty('LAST_NAME')) {
            result['FIO'] = '';

            if (result.hasOwnProperty('LAST_NAME'))
                result['FIO'] = result['LAST_NAME'];

            if (result.hasOwnProperty('NAME')) {
                if (result['FIO'].length)
                    result['FIO'] += ' ';

                result['FIO'] += result['NAME'];
            }
        }

        return result;
    }

    static addOrder(data, productId, loadUrl) {
        let body = new FormData();

        for (let i in data) {
            if (!data.hasOwnProperty(i)) continue;

            if (Array.isArray(data[i])) {
                data[i].forEach(item => body.append(i, item));
            } else {
                body.append(i, data[i]);
            }
        }

        body.append('action', 'saveOrderAjax');
        body.append('soa-action', 'saveOrderAjax');
        body.append('PERSON_TYPE', '1');
        body.append('PERSON_TYPE_OLD', '1');

        if (productId) {
            body.append(`productId`, productId);
        }


        return fetch(loadUrl, {
            method: 'POST',
            body: body
        });
    }
}

export {ApplePayHelper};